import type { FormikErrors, FormikHelpers } from 'formik';

export interface ApiErrorResponse {
  errors?: Record<string, Array<string>>;
  message?: string;
}

/**
 * Handles mapping backend JSON API errors to Formik fields.
 * Expects errors in format: { errors: { fieldName: ["error message"] } }
 */
export const handleFormikApiErrors = async <T>(
  error: unknown,
  formikHelpers: FormikHelpers<T>,
) => {
  const apiError = error as {
    response?: { clone: () => { json: () => Promise<ApiErrorResponse> } };
  };
  if (apiError.response) {
    try {
      const data = await apiError.response.clone().json();
      if (data.errors) {
        const formikErrors: Record<string, string> = {};
        Object.keys(data.errors).forEach((key) => {
          formikErrors[key] = data.errors![key][0];
        });
        formikHelpers.setErrors(formikErrors as unknown as FormikErrors<T>);
      }
    } catch (e) {
      // JSON parsing or structure failed, stay silent and let generic error handling handle it
      console.error('Failed to parse API error for Formik', e);
    }
  }
};
